import { IonIcon, IonButton } from '@ionic/react';
import { arrowBackOutline } from 'ionicons/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import PropTypes from 'prop-types';
import { Capacitor } from '@capacitor/core';
 
const BackButton = ({ parts }) => {
  const { isMobile, activeComponent, setActiveComponent } = useMobileSettings();
  const navigate = useNavigate();
  const { user } = useAuthUser();
  const location = useLocation();
  const iOS =   Capacitor.getPlatform() === 'ios';
  const handleBack = () => {
    if (parts.includes('product-details')) {
      navigate(`/${user?.roleMenuFlag[0]}/product-listing`);
    } else if (parts.includes('checkout-tilled')) {
      navigate('/cart');
    } else if (parts.includes('package-details')) {
      navigate(`/${user?.roleMenuFlag[0]}/product-listing`);
    } else if (parts.includes('transactionHistoryMob') && activeComponent) {
      setActiveComponent(null);
    } else {
      navigate(`/${user?.roleMenuFlag[0]}/settingsTab`);
    }
  };

  // Define paths where back button should NOT appear
  const excludedPaths = [
    `/${user?.roleMenuFlag[0]}/product-listing`,
    `/${user?.roleMenuFlag[0]}/activity-calendar`,
    `/${user?.roleMenuFlag[0]}/events`,
    `/${user?.roleMenuFlag[0]}/settingsTab`,
    `/signin`,
  ];

  // Show button only if mobile AND current path is NOT excluded
  const shouldShowBackButton =
    isMobile && !excludedPaths.includes(location.pathname);

  return (
    shouldShowBackButton && (
      <IonButton
        onClick={handleBack}
        fill='clear'
        style={{
          position: 'absolute',
          top: iOS? '20px' : 0,
          left: '0px',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          padding: '0',
        }}
      >
        <IonIcon
          icon={arrowBackOutline}
          style={{ fontSize: '20px', color: '#000000' }}
        />
      </IonButton>
    )
  );
};

export default BackButton;
BackButton.propTypes = {
  parts: PropTypes.array,
};
